import {
    CREATE_PRODUCT,
    RETRIEVE_PRODUCTS,
    RETRIEVE_ACTIVE_PRODUCTS,
    UPDATE_PRODUCT
} from "../../actions/types";

const initialState = [];

function productReducer(products = initialState, action) {
    const {type, payload} = action;
    switch (type) {
        case CREATE_PRODUCT:
            return [...products, payload];
        case RETRIEVE_PRODUCTS:
        case RETRIEVE_ACTIVE_PRODUCTS:
            return payload;
        case UPDATE_PRODUCT:
            return products.map((product) => {
                if (product.Product_id === payload.Product_id) {
                    return {
                        ...product,
                        ...payload
                    };
                } else {
                    return product;
                }
            });
        default:
            return products;
    }
}

export default productReducer;